export default __webpack_public_path__ + "assets/images/a7556a0f47840125ae3fe4743b56f68c.svg";